var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5482 8.75928C12.0356 14.4125 3.97925 14.5109 1.48457 8.89792C1.23952 8.34654 1.23952 7.71715 1.48457 7.16577C3.97925 1.55274 12.0356 1.65115 14.5482 7.30441C14.7517 7.76225 14.7517 8.30144 14.5482 8.75928Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98448 10.2893C9.2315 10.2893 10.2424 9.27837 10.2424 8.03136C10.2424 6.78434 9.2315 5.77344 7.98448 5.77344C6.73747 5.77344 5.72656 6.78434 5.72656 8.03136C5.72656 9.27837 6.73747 10.2893 7.98448 10.2893Z",
    stroke: "#424242",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6645 2.41602L3.30469 14.5837",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthVisibilityOff);
export default __webpack_public_path__ + "static/media/auth-visibility-off.ff94eba73b9c0a8bcdb0ee41977499df.svg";
export { ForwardRef as ReactComponent };